import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
  isActive?: boolean;
}

const NotificationSvg: FC<Props> = ({ className, color, isActive }) => {
  if (isActive) {
    return (
      <svg
        className={className}
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12 3.52501C9.9126 3.52501 8.11541 4.99835 7.70604 7.04519L6.77725 11.6891C6.50871 13.0319 5.84873 14.265 4.88049 15.2333L4.5898 15.524C4.38822 15.7255 4.27498 15.9989 4.27498 16.284C4.27498 16.7845 4.62045 17.2188 5.10816 17.3314L6.33997 17.6156C10.0644 18.4751 13.9356 18.4751 17.66 17.6156L18.8918 17.3314C19.3795 17.2188 19.725 16.7845 19.725 16.284C19.725 15.9989 19.6117 15.7255 19.4102 15.524L19.1195 15.2333C18.1512 14.265 17.4912 13.0319 17.2227 11.6891L17.1214 11.1828C17.024 10.6954 17.3401 10.2213 17.8275 10.1238C18.3149 10.0263 18.789 10.3424 18.8865 10.8298L18.9877 11.3361C19.1866 12.3304 19.6753 13.2435 20.3923 13.9605L20.6829 14.2512C21.2221 14.7903 21.525 15.5216 21.525 16.284C21.525 17.6227 20.601 18.7843 19.2965 19.0853L18.0647 19.3695C17.0431 19.6053 16.0111 19.7807 14.9741 19.8958C14.7805 21.3656 13.5227 22.5001 12 22.5001C10.4772 22.5001 9.21947 21.3656 9.02583 19.8958C7.98884 19.7807 6.95687 19.6053 5.93522 19.3695L4.70341 19.0853C3.39899 18.7843 2.47498 17.6227 2.47498 16.284C2.47498 15.5216 2.77786 14.7903 3.31701 14.2512L3.6077 13.9605L4.24409 14.5969L3.6077 13.9605C4.32466 13.2435 4.81336 12.3304 5.01221 11.3361L5.941 6.69218C6.51864 3.80398 9.05458 1.72501 12 1.72501C12.6063 1.72501 13.1963 1.81327 13.7556 1.97901C14.2322 2.12021 14.5041 2.62103 14.3629 3.0976C14.2217 3.57418 13.7209 3.84606 13.2443 3.70485C12.8489 3.58769 12.4311 3.52501 12 3.52501ZM18.75 8.25001C20.4068 8.25001 21.75 6.90686 21.75 5.25001C21.75 3.59315 20.4068 2.25001 18.75 2.25001C17.0931 2.25001 15.75 3.59315 15.75 5.25001C15.75 6.90686 17.0931 8.25001 18.75 8.25001Z'
          fill={color ?? 'currentColor'}
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M18.75 8.25C20.4069 8.25 21.75 6.90685 21.75 5.25C21.75 3.59315 20.4069 2.25 18.75 2.25C17.0931 2.25 15.75 3.59315 15.75 5.25C15.75 6.90685 17.0931 8.25 18.75 8.25Z'
          fill='#FF3333'
        />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M16.5146 7.00105L17.4434 11.645L19.2084 11.292L17.4434 11.645C17.7032 12.9442 18.3418 14.1373 19.2786 15.0742L19.5693 15.3649C19.813 15.6086 19.95 15.9393 19.95 16.284C19.95 16.8893 19.5322 17.4145 18.9424 17.5506L17.7106 17.8349C13.9529 18.702 10.0471 18.702 6.2894 17.8349L5.05759 17.5506C4.46779 17.4145 4.05 16.8893 4.05 16.284C4.05 15.9393 4.18695 15.6086 4.43072 15.3649L4.72141 15.0742C5.65825 14.1373 6.29681 12.9442 6.55664 11.645L7.48544 7.00106C7.91584 4.84905 9.80537 3.3 12 3.3C14.1946 3.3 16.0842 4.84905 16.5146 7.00105ZM14.9345 20.1265C16.0019 20.0106 17.064 19.8314 18.1154 19.5888L19.3472 19.3045C20.7537 18.9799 21.75 17.7275 21.75 16.284C21.75 15.4619 21.4234 14.6734 20.8421 14.0921L20.5514 13.8014C19.8658 13.1158 19.3985 12.2427 19.2084 11.292L18.2796 6.64804C17.6809 3.65467 15.0527 1.5 12 1.5C8.94735 1.5 6.31906 3.65468 5.72039 6.64805L4.7916 11.292C4.60146 12.2427 4.13417 13.1158 3.44862 13.8014L3.15793 14.0921C2.57659 14.6734 2.25 15.4619 2.25 16.284C2.25 17.7275 3.24633 18.9799 4.65284 19.3045L5.88465 19.5888C6.93598 19.8314 7.99815 20.0106 9.06548 20.1265C9.35353 21.4827 10.5579 22.5001 12 22.5001C13.4421 22.5001 14.6465 21.4827 14.9345 20.1265Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};

export default NotificationSvg;
